import { assertEnv } from "@homeinstead/shared";

export function isProduction(): boolean {
  const nodeEnv = assertEnv("NODE_ENV", process.env.NODE_ENV);
  return nodeEnv === "production";
}
